import { render, staticRenderFns } from "./AlertDetail.vue?vue&type=template&id=03fcb430&"
import script from "./AlertDetail.vue?vue&type=script&lang=js&"
export * from "./AlertDetail.vue?vue&type=script&lang=js&"
import style0 from "./AlertDetail.vue?vue&type=style&index=0&id=03fcb430&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports